import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "sales";
// initial state
const state = () => ({
  all: [],
  sales: [],
  items: [],
  sale: {},
  report: [],
  reportPyments: [],
  currentPage: 1,
  perPage: 10,
  totalItems: 0,
  errors: [],
  statisticsReport: [],

  creditBalances: [],
  discounts: [],
});

// getters
const getters = {
  getAll: (state) => state.all,
  getErrors: (state) => state.errors,
  getSales: (state) => state.sales,
  getStatisticsReport: (state) => state.statisticsReport,
  getCurrentPage: (state) => state.currentPage,
  getPerPage: (state) => state.perPage,
  getTotalItems: (state) => state.totalItems,

  getSale: (state) => state.sale,
  getItems: (state) => state.items,

  getReport: (state) => state.report,
  getReportPayments: (state) => state.reportPyments,
  getReportCreditBalances: (state) => state.creditBalances,
  getReportDiscounts: (state) => state.discounts,
  getTotalReportPayments: (state) =>
    state.reportPyments.reduce((acc, val) => acc + parseFloat(val.amount), 0),

  getLineChartDataReport: (state) => {
    const cumulativeTotalPriceTTC = state.report.reduce((acc, curr) => {
      const previousSum = acc.length > 0 ? acc[acc.length - 1] : 0;
      const currentSum = previousSum + curr.totalPriceTTC;
      acc.push(currentSum);
      return acc;
    }, []);

    const cumulativeAmountPaid = state.report.reduce((acc, curr) => {
      const previousSum = acc.length > 0 ? acc[acc.length - 1] : 0;
      const currentSum = previousSum + curr.amountPaid;
      acc.push(currentSum);
      return acc;
    }, []);

    const cumulativeAmountUnpaid = state.report.reduce((acc, curr) => {
      const previousSum = acc.length > 0 ? acc[acc.length - 1] : 0;
      const currentSum = previousSum + curr.amountUnpaid;
      acc.push(currentSum);
      return acc;
    }, []);

    return {
      labels: state.report != "" ? state.report.map(({ date }) => date) : [""],
      datasets: [
        {
          label: "Montant Total",
          data: cumulativeTotalPriceTTC,
          borderColor: "#337dff",
          borderWidth: 1,
        },
        {
          label: "Montant Payé",
          data: cumulativeAmountPaid,
          borderColor: "#33ff71",
          borderWidth: 1,
        },
        {
          label: "Montant Restant",
          data: cumulativeAmountUnpaid,
          borderColor: "#ff3333",
          borderWidth: 1,
        },
      ],
    };
  },

  totalPriceTTCItems: (state) =>
    state.items.reduce(
      (acc, val) => acc + parseFloat(val.quantity) * parseFloat(val.priceTTC),
      0
    ),

  totalQuantityItems: (state) =>
    state.items.reduce((acc, val) => acc + parseFloat(val.quantity), 0),
  numberItems: (state) => parseFloat(state.items.length),
  // Customer Report
  getTotalQuantity: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.totalQuantity), 0),
  getTotalPriceTTC: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.totalPriceTTC), 0),
  getTotalPaid: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.amountPaid), 0),
  getTotalUnpaid: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.amountUnpaid), 0),
  getTotalDiscount: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.discount), 0),

  // Sales
  getSalesTotalQuantity: (state) =>
    state.sales.reduce((acc, val) => acc + parseFloat(val.totalQuantity), 0),
  getSalesTotalPriceTTC: (state) =>
    state.sales.reduce((acc, val) => acc + parseFloat(val.totalPriceTTC), 0),
  getSalesTotalPaid: (state) =>
    state.sales.reduce((acc, val) => acc + parseFloat(val.amountPaid), 0),
  getSalesTotalUnpaid: (state) =>
    state.sales.reduce((acc, val) => acc + parseFloat(val.amountUnpaid), 0),
  getSalesTotalDiscount: (state) =>
    state.sales.reduce((acc, val) => acc + parseFloat(val.discount), 0),
};

// actions
const actions = {
  async fetchSales({ commit, dispatch, state }) {
    const data = await this.$api.fetch(api);

    if (data == -1) {
      dispatch(
        "notification/store",
        {
          status: "warning",
          message: "Pas de données, la liste des ventes est vide.",
        },
        { root: true }
      );
    }
    commit("SET_SALES", Array.isArray(data) ? data : []);
  },

  async getAll({ commit }) {
    const sales = await this.$api.fetch(api);
    commit("SET_SALES", Array.isArray(sales) ? sales : []);
  },

  async fetchAllStatistics({ commit }, data) {
    const response = await this.$api.create(api + "_statistics_report", data, {
      confirm: false,
    });
    commit("SET_STATISTICS_REPORT", response.data || []);
  },

  async getTodays({ commit }) {
    const sales = await this.$api.fetch(api + "_todays");
    commit("SET_SALES", Array.isArray(sales) ? sales : []);
  },

  async getAllItems({ commit }) {
    const items = await this.$api.fetch(api + "_items");
    commit("setItems", Array.isArray(items) ? items : []);
  },

  async show({ commit }, reference) {
    commit("setSale", {});
    const response = await this.$api.show(api + "/" + reference);
    const sale = response.data || response || {};
    commit("setSale", sale);
  },

  async reportCustomer({ commit }, data) {
    const reportsApi = constant.api + "reports";
    const response = await this.$api.create(
      reportsApi + "/customer_report",
      data,
      { confirm: false }
    );
    const responseData = response.data || {};
    let report = responseData.sales || [];
    let payments = responseData.payments || [];
    let discounts = responseData.discounts || [];
    let creditBalances = responseData.creditBalances || [];
    commit("setReport", report);
    commit("SET_REPORT_PAYMENTS", payments);
    commit("SET_REPORT_DISCOUNTS", discounts);
    commit("SET_REPORT_CREDIT_BALANCES", creditBalances);
  },

  async getCustomerSalesUnpaid({ commit }, customer_reference) {
    const sales = await this.$api.fetch(api + "_unpaid/" + customer_reference);
    commit("SET_SALES", Array.isArray(sales) ? sales : []);
  },

  async recalculationPrices({ commit, dispatch }, reference) {
    const response = await this.$api.create(
      api + "_recalculation_prices/" + reference,
      {},
      { confirm: false }
    );
    const sale = response.data.data || {};
    commit("setSale", sale);
  },

  async addManutention({ commit, dispatch }, reference) {
    const response = await this.$api.create(
      api + "_manutention/" + reference,
      {},
      { confirm: false }
    );
    const sale = response.data.data || {};
    commit("setSale", sale);
  },

  async store({ commit, dispatch }, data) {
    const response = await this.$api.create(api, data);
    const status = response.data.status;

    if (status == "success") {
      router.push({
        name: "sales-index",
      });
    }
  },

  async storeItem({ commit, dispatch }, data) {
    const response = await this.$api.create(api + "_items", data, {
      confirm: false,
    });
    const status = response.data.status;

    if (status == "success") {
      commit("setItems", response.data.data || []);
    }
  },

  async updateItem({ commit, dispatch }, data) {
    const response = await this.$api.update(api + "_items/" + data.id, data);
    let message = response.data.message;
    let status = response.data.status;

    dispatch("notification/store", { status, message }, { root: true });
    if (status == "success") {
      commit("setItems", response.data.data || []);
    }
  },

  async update({ commit, dispatch }, data) {
    const response = await this.$api.update(api + "/" + data.reference, data);
    const status = response.data.status;
    const sale = response.data.data || {};
    if (status == "success") {
      router.push({
        name: "sales-details",
        params: {
          reference: sale.reference,
        },
      });
    }
  },

  async validate({ commit, dispatch }, data) {
    const response = await this.$api.create(
      api + "_validate",
      { reference: data },
      { confirm: false }
    );
    let message = response.data.message;
    let status = response.data.status;
    dispatch("notification/store", { status, message }, { root: true });
    if (status == "success") {
      router.push({
        name: "sales-index",
      });
    }
  },

  async destroyItem({ commit, dispatch }, id) {
    const response = await this.$api.delete(api + "_items/" + id, {
      confirm: false,
    });
    const message = response.data.message;
    const status = response.data.status;

    if (status == "success") {
      commit("setItems", response.data.data || []);
    }
  },

  async destroy({ dispatch }, reference) {
    const response = await this.$api.delete(api + "/" + reference);
    const status = response.data.status;
    if (status == "success") {
      router.push({ name: "sales-index" });
    }
  },

  async print({ dispatch }, reference) {
    await printData([], `${api}_print_page`, "GET", reference);
  },

  async printManyBill({ dispatch }, data) {
    await printData(
      { selections: data },
      `${api}_print_many_bill`,
      "POST",
      null
    );
  },

  async printQuotation({ dispatch }, reference) {
    await printData([], `${api}_print_quotation`, "GET", reference);
  },

  async printInvoice({ dispatch }, reference) {
    await printData([], `${api}_print_invoice`, "GET", reference);
  },

  async printReportCustomer({ dispatch }, data) {
    await printData(data, `${api}_customer_report_print`, "POST", null);
  },

  async printGeneralReportCustomer({ dispatch }, data) {
    await printData(data, `${api}_customer_general_report_print`, "POST", null);
  },

  async filter({ dispatch, commit }, data) {
    const response = await this.$api.create(api + "_filter", data, {
      confirm: false,
    });
    commit("SET_SALES", Array.isArray(response.data) ? response.data : []);
  },

  async uploadOrderItems({ commit, dispatch }, reference) {
    const response = await this.$api.fetch(
      api + "_upload_order_items/" + reference
    );
    // Handle if response is already data or if it's a response object
    const responseData = response.data || response || {};
    let message = responseData.message;
    let status = responseData.status;

    if (message && status) {
      dispatch("notification/store", { status, message }, { root: true });
    }
    if (status == "success" && responseData.data) {
      commit("setItems", responseData.data || []);
    }
  },

  async archiveReportCustomer({ commit }, data) {
    const response = await this.$api.create(
      api + "_customer_report_archive",
      data,
      { confirm: false }
    );
    const responseData = response.data || {};
    let report = responseData.sales || [];
    let payments = responseData.payments || [];
    let discounts = responseData.discounts || [];
    let creditBalances = responseData.creditBalances || [];
    commit("setReport", report);
    commit("SET_REPORT_PAYMENTS", payments);
    commit("SET_REPORT_DISCOUNTS", discounts);
    commit("SET_REPORT_CREDIT_BALANCES", creditBalances);
  },
};

// mutations
const mutations = {
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  SET_SALES(state, sales) {
    state.all = sales;
    state.sales = sales;
  },
  SET_TOTAL_ITEMS(state, total) {
    state.totalItems = total;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  setSale(state, sale) {
    state.sale = sale;
  },
  setReport(state, report) {
    state.report = report;
  },
  SET_REPORT_PAYMENTS(state, data) {
    state.reportPyments = data;
  },
  SET_REPORT_CREDIT_BALANCES(state, data) {
    state.creditBalances = data;
  },
  SET_REPORT_DISCOUNTS(state, data) {
    state.discounts = data;
  },
  SET_STATISTICS_REPORT(state, data) {
    state.statisticsReport = data;
  },
  setItems(state, items) {
    state.items = items;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.sales = state.all.filter(function (sale) {
      return (
        sale.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        sale.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        sale.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        sale.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
